import { ImageMetadata, PexelsSearchResponse, PixabaySearchResponse } from 'types/imageLibsTypes';

const PEXELS_SMALL_IMAGE_HEIGHT = 130;

/**
 * Combine the response from both pixabay and the pexels api
 * Then return a formatted array of ImageMetadata,
 * which would have a page from pexels and a page from pixabay alternately
 *
 * @param pixabayResponses
 * @param pexelsResponses
 * @returns
 */
export const combineImageSearchResults = (
  pixabayResponses: PixabaySearchResponse[] = [],
  pexelsResponses: PexelsSearchResponse[] = [],
): ImageMetadata[] => {
  const formattedPexelsResponse: ImageMetadata[][] = pexelsResponses.map((pexelsResponse) => {
    return pexelsResponse.photos.map((photo) => {
      const smallImageWidth = (photo.width * PEXELS_SMALL_IMAGE_HEIGHT) / photo.height;

      return {
        id: photo.id,
        author: photo.photographer,
        source: 'Pexels',
        alt: photo.alt,
        url: photo.src.large2x,
        imageWidth: photo.width,
        imageHeight: photo.height,
        previewURL: photo.src.small,
        previewWidth: smallImageWidth,
        previewHeight: PEXELS_SMALL_IMAGE_HEIGHT,
      };
    });
  });

  const formattedPixabayResponse: ImageMetadata[][] = pixabayResponses.map((pixabayResponse) => {
    return pixabayResponse.hits.map((hit) => {
      return {
        id: hit.id,
        author: hit.user,
        source: 'Pixabay',
        alt: hit.tags,
        url: '', // pixabay doesn't provide the persistent image url
        imageWidth: hit.webformatWidth,
        imageHeight: hit.webformatHeight,
        previewURL: hit.previewURL,
        previewWidth: hit.previewWidth,
        previewHeight: hit.previewHeight,
        webformatURL: hit.largeImageURL,
      };
    });
  });

  const results = formattedPixabayResponse;
  formattedPexelsResponse.forEach((pexelsResponse, index) => {
    results.splice(index * 2, 0, pexelsResponse);
  });

  return results.flat();
};
